import { FC } from 'react';
import { DocumentChapter } from '@/types/note';
import DocumentChapters from '../DocumentChapters/DocumentChapters';
import useAudioStore from '@/stores/audioStore';

interface AudioChaptersProps {
  chapters: DocumentChapter[];
  isProcessing: boolean;
  isOwner?: boolean;
  onChaptersUpdate?: (chapters: DocumentChapter[]) => Promise<void>;
}

const AudioChapters: FC<AudioChaptersProps> = ({ chapters, isProcessing, isOwner = false, onChaptersUpdate }) => {
  const { setProgressCurrentTime, setProgressTime, setWavesurferCurrentTime } = useAudioStore();

  const handleLinkClick = (time: number) => {
    setProgressCurrentTime(time);
    setProgressTime();
    setWavesurferCurrentTime();
  };

  return (
    <DocumentChapters
      chapters={chapters}
      handleChapterClick={handleLinkClick}
      isProcessing={isProcessing}
      isOwner={isOwner}
      onChaptersUpdate={onChaptersUpdate}
    />
  );
};

export default AudioChapters;
